
import { NewsComponent } from "../news/news.component"
import { NewsListComponent } from "../news/newslist.component"
import { LocalNavComponent } from "../local-nav.component"
import { DarkModeSwitcher } from '../dark-mode/dark-mode-switcher.component'
import { GlobalSearchComponent } from '../global-search/components/search/global-search.component'
import { AssetScreenerComponent } from '../assetScreener/components/assetScreener.component'
import { PaymentsComponent } from '../profile/Payments/Payments.component'
import { GlobalSearchOpener } from '../global-search/components/opener/global-search-opener.component'
import { SearchHitComponent } from '../global-search/components/search-hit/search-hit.component'
import { TokenDataContainer } from "../tokenData/components/tokenDataContainer"
import { SigninComponent } from "../auth/components/signin/signin.component"
import { AuthState } from "../auth/components/auth-state.component"
import { NumberComponent } from "../numbers/number.component"
import { TbwNewsletterFormComponent } from "../newsletter/tbw-newsletter-form.component"
import { SignoutButtonComponent } from "../auth/components/signout/signout-btn.component"

import { ChartManager } from "../charts/charts.manager"

const components = [
  // Auth
  { name: 'tbw-signin', component: SigninComponent },
  { name: 'tbw-auth-state', component: AuthState },
  { name: 'tbw-signout-btn', component: SignoutButtonComponent },

  // Dev
  { name: 'tbw-local-nav', component: LocalNavComponent },

  // News
  { name: 'tbw-news', component: NewsComponent },
  { name: 'tbw-news-list', component: NewsListComponent },

  // Token Data
  { name: 'tbw-token-data-container', component: TokenDataContainer },

  // Design
  { name: 'tbw-dark-mode-switcher', component: DarkModeSwitcher },

  // Asset Screener
  { name: 'tbw-asset-screener', component: AssetScreenerComponent },

  // Payments
  { name: 'tbw-payments', component: PaymentsComponent },

  // Global Search
  { name: 'tbw-global-search-opener', component: GlobalSearchOpener },
  { name: 'search-hit', component: SearchHitComponent },
  { name: 'tbw-global-search', component: GlobalSearchComponent },

  { name: 'tbw-newsletter-form', component: TbwNewsletterFormComponent },
  { name: 'tbw-number', component: NumberComponent },
]


export const registerComponents = () => {
  components.forEach(component => {
    customElements.define(component.name, component.component)
  })
}

// Chart init by its own manager
// const chartManager.
// chartManager.init()